import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Discovery",
    body: "A candid conversation. We diagnose where your brand is speaking clearly — and where it isn't.",
  },
  {
    n: "02",
    title: "Strategy",
    body: "Positioning, audience, voice and visual pillars. The foundation everything else stands on.",
  },
  {
    n: "03",
    title: "Studio",
    body: "Content, campaigns and craft. We produce the work in-studio, with editorial care at every step.",
  },
  {
    n: "04",
    title: "Growth",
    body: "Measured amplification. Paid, organic, or both — always tied to real business outcomes.",
  },
];

const PROCESS_IMG =
  "https://images.unsplash.com/photo-1587522384446-64daf3e2689a?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-40 bg-[#1C1B1A] text-[#FBF9F6]"
    >
      <div className="max-w-7xl mx-auto w-full px-6 md:px-12 grid grid-cols-12 gap-8 md:gap-12">
        <div className="col-span-12 md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="w-8 h-px bg-[#B4A087]"></span>
            <span className="font-mono-label text-[#B4A087]">
              The Process
            </span>
          </div>
          <h2 className="mt-6 font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Four steps.
            <br />
            <span className="italic text-[#B4A087]">No noise.</span>
          </h2>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9 }}
            className="mt-12 wj-image-hover relative aspect-[4/5] overflow-hidden hidden md:block"
          >
            <img
              src={PROCESS_IMG}
              alt="Studio workspace"
              className="w-full h-full object-cover grayscale-[0.25]"
            />
          </motion.div>
        </div>

        <div className="col-span-12 md:col-span-7 md:pl-8 lg:pl-16">
          <ol className="divide-y divide-[#33312E]">
            {STEPS.map((s, idx) => (
              <motion.li
                key={s.n}
                data-testid={`process-step-${s.n}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: idx * 0.08 }}
                className="py-8 md:py-10 grid grid-cols-12 gap-6 items-start group"
              >
                <span className="col-span-2 font-serif-display text-5xl md:text-6xl text-[#B4A087] leading-none">
                  {s.n}
                </span>
                <div className="col-span-10">
                  <h3 className="font-serif-display text-2xl md:text-3xl">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-base md:text-lg text-[#FBF9F6]/70 leading-relaxed max-w-xl">
                    {s.body}
                  </p>
                </div>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
